import React from "react";
import { useTranslation } from "react-i18next";
import { isRouteErrorResponse, useRouteError } from "react-router";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { AuthServerUnreachable } from "../../API/auth";
import ConnectionError from "./ConnectionError";
import ErrorCard from "./ErrorCard";
import RetryButton from "./RetryButton";

function getErrorMessage(error: unknown): string | null {
  if (error instanceof Error) {
    return error.message;
  }
  if (isRouteErrorResponse(error)) {
    return error.statusText || null;
  }
  return null;
}

export default function ErrorComponent(): React.ReactNode {
  const { t } = useTranslation();
  const error = useRouteError();
  // Dev only: in production RUM already receives this error from the API layer,
  // and console.error here would be collected as a duplicate event.
  if (import.meta.env.DEV) {
    console.error(error);
  }

  if (error instanceof AuthServerUnreachable) {
    return <ConnectionError />;
  }

  return (
    <ErrorCard
      icon={<ErrorOutlineIcon sx={{ fontSize: 40 }} />}
      title={t("heading.Error")}
      description={t("text.error_occured")}
      detail={getErrorMessage(error)}
    >
      <RetryButton />
    </ErrorCard>
  );
}
